import { WrapDisabledIcon } from './WrapDisabledIcon';

/**
 * author: Leo SF
 * id 44C4926C-7F82-4A6A-8F55-A7B23E56A9D7
 * name wrap-disabled
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/wrap-disabled.svg
 * tags
 */
export const UnwrapIcon = WrapDisabledIcon;
export default UnwrapIcon